<div class="container">
    <div class="d-flex gap-2">
        <mat-form-field appearance="outline">
            <mat-label>Select Centre</mat-label>
            <mat-select (selectionChange)="onCenterSelected($event)" >
                <!--        <mat-option value="centreCode">centreName</mat-option>-->
                <ng-container *ngFor="let center of ($center|async );" >
                    <mat-option  *ngIf="center.isArchive!=true" [value]="center">{{center.centreName}}</mat-option></ng-container>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>Select Unit</mat-label>
            <mat-select [(ngModel)]="unitSelected" >
                <!--        <mat-option value="centreCode">centreName</mat-option>-->
                    <mat-option *ngFor="let unit of unitsArray;"   [value]="unit.key">{{unit.name}}</mat-option>
            </mat-select>
        </mat-form-field>


        <mat-form-field  appearance="outline">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate [(ngModel)]="start" placeholder="Start date">
                <input matEndDate [(ngModel)]="end" placeholder="End date">
            </mat-date-range-input>
            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>


        <button mat-mini-fab color="accent" (click)="search()"><mat-icon>search</mat-icon></button>
        <button mat-mini-fab color="primary" [disabled]="!showDownload"  (click)="downloadExcel(children,selectedCentre.centreName)"><mat-icon>download</mat-icon></button>
    </div>

    <section>

        <table mat-table [dataSource]="dataSource" id="excel-table" class="mat-elevation-z8">

            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

            <!-- Position Column -->
            <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef> No. </th>
                <td mat-cell *matCellDef="let element;let i=index"> {{i+1}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.firstName}} {{element.lastName}} </td>
            </ng-container>



            <!-- Symbol Column -->
            <ng-container matColumnDef="centre">
                <th mat-header-cell *matHeaderCellDef> Current Centre </th>
                <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
            </ng-container>
            <ng-container matColumnDef="diagnosis">
                <th mat-header-cell *matHeaderCellDef> Diagnosis </th>
                <td mat-cell *matCellDef="let element"> {{getDiagnosis(element.diagnosisSelected)}} </td>
            </ng-container>
            <ng-container matColumnDef="dateOfAdmission">
                <th mat-header-cell *matHeaderCellDef> Date of Admission </th>
                <td mat-cell *matCellDef="let element"> {{element?.dateOfAdmission|date:'dd-MM-yyyy'}} </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[ 100,200,500,1000]" aria-label="Select page of users"></mat-paginator>



    </section>


</div>
